import { ImageLoaderConfig } from '@angular/common';
import { InjectionToken } from '@angular/core';
import { IResizeOptions as IResizeOptionsCore } from '@df/ui/common/resize.service';

declare module '@df/ui/common/resize.service' {
    interface IResizeOptions extends NThumbor.IResizeOptions {}
}

export namespace NThumbor {
    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_THUMBOR_OPTIONS');

    export interface IModuleOptions {
        defaultOptions: Partial<IResizeOptions>;
        useTcoProxy?: boolean;
    }

    export interface IResizeOptions {
        fitIn?: boolean | string;
        fillColor?: string;
        cropType?: string;
        verticalCrop?: string;
        horizontalCrop?: string;
        trim?: boolean | number | string; // true or 1 for default trim, number for tolerance or
        // whole setting string as described: http://thumbor.readthedocs.io/en/latest/usage.html#trim
        sharpen?: number | string | false;
        upscale?: boolean;
        quality?: number | false;
        format?: 'jpeg' | 'webp' | 'gif' | 'png';
        // fillFull is used to fill the whole image with the fill color including the existing part and not only added content
        fillFull?: boolean;
    }

    export interface ILoaderConfig extends ImageLoaderConfig {
        loaderParams: IResizeOptionsCore;
    }
}

/**
 * Extend app.config with module properties
 * @see config/df.config.twig.part
 */
declare module '@df/core/df-core.config' {
    interface IDfConfig {
        thumbor: {
            endpoint: string;
        };
    }
}
